import { render, staticRenderFns } from "./CardCountry.vue?vue&type=template&id=facdcd4c&scoped=true"
import script from "./CardCountry.vue?vue&type=script&lang=js"
export * from "./CardCountry.vue?vue&type=script&lang=js"
import style0 from "./CardCountry.css?vue&type=style&index=0&id=facdcd4c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facdcd4c",
  null
  
)

export default component.exports